const V = {
  primary:{ bg:"#1263B0", color:"#fff" }, cyan:{ bg:"#1CBCD3", color:"#fff" },
  gold:{ bg:"#C9922A", color:"#fff" },
  ghost:{ bg:"transparent", color:"#1263B0", border:"1.5px solid #D1D5DB" },
  danger:{ bg:"transparent", color:"#B91C1C", border:"1.5px solid #FECACA" },
};
export default function Button({ children, onClick, type="button", variant="primary",
  size="md", full=false, loading=false, disabled=false, className="" }) {
  const v = V[variant]||V.primary;
  const pad = size==="sm"?"9px 16px":size==="lg"?"16px 32px":"13px 24px";
  return (
    <button type={type} onClick={onClick} disabled={disabled||loading} className={className}
      style={{ background:(disabled||loading)?"#E2E8F0":v.bg,
        color:(disabled||loading)?"#94A3B8":v.color, border:v.border||"none",
        borderRadius:"12px", padding:pad, fontSize:"14px",
        fontFamily:"'DM Sans',sans-serif", fontWeight:700,
        cursor:(disabled||loading)?"not-allowed":"pointer",
        width:full?"100%":"auto", display:"inline-flex",
        alignItems:"center", justifyContent:"center", gap:"8px" }}>
      {children}
    </button>
  );
}
